<template>

    <b-modal id="upgrade-service"
        centered
        title="Upgrade Your Service"
        @ok="requestUpgrade"
        ok-title="Ok, Upgrade me!"
        ok-variant="success"
        cancel-variant="link">
        <div class="row">
            <div class="col-sm-12">
                <div class="px-12">
                    <p>This will notify our sales team that you would like to upgrade this service. Please allow up to 24 hours for our team to respond and find a suitable upgrade solution.</p>
                    <p>If you require an immediate response, call us now on <a href="tel:+611300788862" class="phone">1300 788 862</a></p>
                </div>
            </div>
        </div>
    </b-modal>

</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        requestUpgrade() {
            // Show spinner while processing
            this.$swal({
                title: "Submitting your request",
                text: "Please wait...",
                imageUrl: "/img/spinner.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });

            // Show processing sweet alert
            this.submitUpgradeRequest().then(response => {
                if(response.data.status == 'success') {
                    // show success modal
                    this.$swal({
                        type:'success',
                        title: 'Upgrade Request Submitted',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    // Update the flag in the parent component to hide the form and prevent multiple submissions
                    this.$emit('updateFlag');
                } else {
                    this.$swal({
                        type:'error',
                        title: 'There seems to be a problem',
                        html: 'There has been a problem subnimtting your request. Please try again.',
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                }
            }).catch(error => {
                // show error modal
                this.$swal({
                    type:'error',
                    title: 'There seems to be a problem',
                    html: 'There has been a problem submitting your request. Please try again.',
                    buttonsStyling: false,
                    confirmButtonText: 'Close',
                    confirmButtonClass: 'btn btn-danger'
                });
            });
        }
    },
}
</script>

<style>
</style>
